$(function () {
    $('.search-select').select2();
})

$('.wrapSelect').on('change', function() {
    $('#pagerForm').submit();
});

